export default {
	home: 'Home',
	contact: 'Contact',
	aboutUs: 'About Us',
	logout: 'Logout',
	login: 'Login',
	register: 'Sign up here',
	search: 'Search',
	login_fa: 'Login with facebook',
	login_go: 'Login with Google',
	sign_in_man: 'Log in manually',
	username: 'Username',
	password: 'Password',
	btn_register: 'Register now',
	btn_lost_pass: 'Forgot password?',
	text_remenber: 'Remember Me',
	check_in: 'Check in',
	itfa_abr: 'INDEPENDENT TELEFOOTBALL ASSOCIATION',
	select_platform: 'Select a platform',
	about_us:
		'<p>In order to get as close to <strong>our way</strong> to run a competition as real as possible in FIFA would like to highlight some details about what your experience in this game.</p><p>Currently we have about 800+ players in our Pro Clubs & Groups 1v1 is soon to be held, where many are involved in one or other of the powers that are exclusive to PS4 due to various reasons.</p><p>Esta página web, esta echa para todos ustedes donde habra torneos sobre FIFA 16.</p><p>– 1 VS 1 where you can demonstrate your ability.</p><p>– PRO CLUBS it is a mode of FIFA 16 online game where you can create a Virtual Pro player and play your own position in the field with your fellow realistically as you can live football online. The more games you play and unlock more feats, Virtual Pro unlock your best attributes and appearance options. Play casual games or join a club or create your own to get points with your own club.</p><p>You can also interact with us, MarDar photos from your club oh video, contact us, ask questions and send suggestions and comments on our way as we have the web and Administration page, ensuring to serve them and respond as soon as possible with a problem that have.</p><p><strong>A cordial greeting.</strong></p><p>We hope to meet your expectations with quality and satisfaction quickly because it is our true FIFA16 philosophy of work.</p>',
	text_contact:
		'<p>Thanks for your visit.</p><p>If you have any suggestions, complaints or comments please write, we will be happy to answer.</p>',
	subject: 'Subject',
	email: 'E-mail',
	name: 'Name',
	message: 'Message',
	messages: 'Messages',
	required: 'Required',
	submit: 'Submit',
	return: 'Return',
	pleaseWait: 'Please wait...',
	registerTitle: 'Registro de Usuarios',
	repeatPassword: 'Repeat your password',
	country: 'Country',
	position: 'Position',
	console: 'Console',
	motto: 'Motto',
	selectOption: 'Select option',
	allRightsReserved: 'All rights reserved',
	profile: 'Profile',
	myProfile: 'My profile',
	friends: 'Friends',
	edit: 'Edit',
	editUser: 'Edit my information',
	language: 'Language',
	save: 'Save',
	changePassword: 'Change password',
	currentPassword: 'Current password',
	newPassword: 'New password',
	repeatNewPassword: 'Repeat new password',
	options: 'Options',
	createAdmins: 'Create administrators',
	sliderPrimary: 'Slider primary',
	changeGt: 'Change gamertag',
	toPremium: 'Switch to premium',
	updatedData: 'Update data',
	tutorialCreate: 'Create tutorial',
	bets: 'Betting',
	textChangeImgSlider:
		'<li>The image should have no more weight than 2MB.</li><li>Minimum resolution 1366 x 598 pixels.</li><li>The only permitted extension is JPG.</li>',
	findImage: 'Image search',
	details: 'Details',
	updatedInfo: 'Updated information.',
	create: 'Create',
	title: 'Title',
	delete: 'Delete',
	error404: 'Resource does not exist.',
	enterUserId: 'Enter the id of a user',
	cancel: 'Cancel',
	confirmTitleDelete: 'Confirm delete',
	confirmTextDelete: 'You are sure to delete the selected item ?',
	editInfoUser: 'Edit users information',
	resetPassword: 'Reset your password',
	enterYourEmail: 'Enter your email',
	myNews: 'My news',
	image: 'Image',
	published: 'Published',
	modified: 'Modified',
	comments: 'Comments',
	date: 'Date',
	time: 'Time',
	createdAgo: 'Created ago',
	content: 'Content',
	cover: 'Cover page',
	show: 'Show',
	enterIdOrUsername: 'Enter a players ID or username',
	month: 'month | months',
	year: 'year | years',
	selectPlatform: 'Select a platform',
	langEs: 'Spanish',
	langEn: 'English',
	langPt: 'Portuguese',
	description: 'Description',
	videoCode: 'Video code',
	order: 'Order',
	tournaments: 'Tournaments',
	tournament: 'Tournament',
	favorites: 'Favorites',
	online: 'Online',
	notices: 'News',
	readMore: 'Read more',
	seeAllNews: 'See all the news',
	rankingPlayers: 'Player rankings',
	rankingTeams: 'Ranking equipment',
	lastMatches: 'Last matches',
	round: 'round | rounds',
	theBest: 'The best',
	signings: 'Signings',
	rules: 'Rules',
	divisions: 'Divisions',
	division: 'Division',
	teams: 'Teams',
	team: 'Team',
	transfers: 'Transfers',
	assistances: 'Assistances',
	scorer: 'Scorer | Scorers',
	transferClose: '{time} left until closing',
	transferOpen: '{time} left to open',
	goal: 'goal | goals',
	assistance: 'assist | assists',
	goalkeeper: 'Goalkeeper | Goalkeepers',
	bestPlayer: 'Best player',
	point: 'point | points',
	bestDefense: 'The best defense',
	bestOffensive: 'The best offensive',
	goalFavor: 'goal in favor | goals in favor',
	goalAgainst: 'goal against | goals against',
	player: 'Player',
	players: 'Players',
	ranking: 'Ranking',
	status: 'Status',
	price: 'Price',
	purchasedBy: 'Purchased by',
	availableMoney: 'Available money',
	free: 'Libre',
	signing: 'Signed',
	playedGames: 'Matches played',
	yellowCard: 'yellow card | yellow cards',
	redCard: 'red card | red cards',
	joinTheMarket: 'Join the market',
	joinTheMarketConfirm:
		'Are you sure you want to join the list of free players in the tournament?',
	yes: 'Yes',
	not: 'Not',
	notice: 'Notice',
	contract: 'Contract',
	sellPlayers: 'Sell players',
	pendingRounds: 'Pending rounds',
	sellerPlayerConfirm: 'Are you sure you want to sell to the selected player?',
	table: 'Table',
	card: 'card | cards',
	teamWeek: 'Team of the week',
	nextMatches: 'Next matches',
	results: 'Results',
	privateMsgFor: 'Private message for {user}',
	pj: 'GP',
	pg: 'GW',
	pe: 'GT',
	pp: 'GL',
	gf: 'GF',
	gc: 'GA',
	dg: 'GD',
	seeDT: 'See DT',
	matches: 'Matches',
	quantity: 'Quantity',
	training: 'Training',
	defense: 'Defenses',
	midfielders: 'Midfielders',
	front: 'Front',
	award: 'award | awards',
	champion: 'CHAMPION',
	stats: 'Statistics',
	type: 'Type',
	record: 'Record',
	changeImage: 'Change image',
	addTeam: 'Add team',
	textFindNotice: 'Enter one or more letters and then press ENTER',
	sendInvitation: 'Send invitation',
	createTournament: 'Create tournament',
	editTournament: 'Edit tournament',
	mode: 'mode',
	category: 'category | categories',
	hideTournament: 'Hide tournament?',
	deleteAllPlayersOfTeam:
		'Are you sure to delete all the players of the selected team?',
	handOutMoney: 'Hand out money',
	add: 'Add',
	remove: 'Remove',
	transfersClosed: 'Transfers - is closed',
	transfersOpened: 'Transfer - is open',
	transfersClosedMsg:
		'Transfer is closed, the players who were invited will be able to enter the team.',
	transfersOpenedMsg:
		'Transfer is open, players who were invited and did not accept can not enter the team until the next signing.',
	open: 'Open',
	close: 'Close',
	customButtons: 'Custom buttons',
	label: 'Label',
	showIn: 'Show in',
	selfLink: 'In the same page',
	blankLink: 'On another page',
	views: 'Views',
	administrator: 'administrator | administrators',
	enterPlayerNick: 'Enter a player´s nickname',
	user: 'user',
	roundsFinalPhase: 'ROUNDS + FINAL PHASE',
	allFinalPhase: 'ALL AGAINST ALL + FINAL PHASE',
	manualDirectDisposal: 'MANUAL DIRECT DISPOSAL',
	autoDirectDisposal: 'AUTOMATIC DIRECT DISPOSAL',
	numberTeamsDown: 'Number of teams that are down',
	numberTeamsPassLiguilla: 'Number of teams passing wing liguilla',
	season: 'season | seasons',
	deliverCup: 'Deliver cup',
	removeCup: 'REMOVE CUP',
	toStart: 'TO START',
	programming: 'PROGRAMMING',
	inProgress: 'IN PROGRESS',
	finished: 'FINISHED',
	played: 'PLAYED',
	notPresented: 'WON BY DEFAULT',
	changeDatesRounds: 'Change dates rounds',
	addPlayTime: 'Add play time',
	selectDays: 'Select one or more days of the week',
	monday: 'Monday',
	tuesday: 'Tuesday',
	wednesday: 'Wednesday',
	thursday: 'Thursday',
	friday: 'Friday',
	saturday: 'Saturday',
	sunday: 'Sunday',
	schedule: 'Game schedule',
	transferDate: 'Transfer date',
	dateNextSigning: 'Date of next signing',
	endDate: 'Deadline',
	choose: 'Choose',
	alternate: 'Alternate',
	showFixture: 'Show fixture',
	msgCreateFixture:
		'After creating the fixture you can no longer add more equipment to the tournament. Sure to continue?',
	createFixture: 'Create fixture',
	btnIfContinue: 'If i want to continue',
	createLiguilla: 'Create liguilla',
	thirdPlace: 'Third place',
	myClub: 'My club',
	myTeams: 'My teams',
	myGames: 'My games',
	management: 'Management',
	tshirts: 'Tshirts',
	notification: 'notification | notifications',
	from: 'From',
	detailsNotification: 'Details notification',
	invitation: 'invitation | invitations',
	accept: 'Accept',
	deny: 'Deny',
	invitationAccepted: 'Invitation accepted.',
	invitationRejected: 'Invitation rejected.',
	transferPlayer: 'Transfer player',
	freePlayerPremium: 'Do you want to release the selected player?',
	trainingShow: 'Training to show',
	teamFormation: 'Team formation',
	myFormation: 'My formation',
	invitePlayers: 'Invited players',
	myFavouriteTeams: 'My favorite teams',
	myFavouriteTournaments: 'My favorite tournaments',
	visitor: 'Visitor',
	watchMatch: 'Watch match',
	editVideos: 'Edit videos',
	addPictures: 'Add pictures',
	toUpdate: 'To update',
	editMatch: 'Edit the match results',
	participated: 'Join',
	none: 'None',
	changeResultMatch: 'Change results of a match',
	changeResults: 'Change the results',
	changeStatistics: 'Change the statistics',
	enabledStatistics: 'Enable editing of statistics',
	all: 'All',
	coins: 'Coins',
	duration: 'Duration',
	toBuy: 'To buy',
	relatedProducts: 'Related products',
	purchasedProducts: 'Products purchased',
	boughtOn: 'Bought on',
	beatOn: 'Beat on',
	use: 'USE',
	addCategory: 'Add category',
	bgTournaments: 'Background image for the tournaments',
	bgDivisions: 'Background image for divisions',
	bgTeams: 'Background image for teams',
	bgPlayers: 'Background image for players',
	editCategory: 'Edit category',
	addSubcategory: 'Add subcategory',
	editSubcategory: 'Edit subcategory',
	createProduct: 'Create product',
	visible: 'Visible',
	editProduct: 'Edit product',
	cardNumber: 'Card number',
	expirationDate: 'Expiration date',
	matchBetting: 'Match Betting',
	matchWin: 'Match win',
	bet: 'Bet',
	gain: 'Gain',
	matchesBet: 'Matches with bet',
	entry: 'Entry',
	betMsgEntry:
		'It will deduct (<strong>{coin}</strong>) of your coins to play this game',
	confirmResults: 'Confirm results',
	whatLokingFor: '¿What are you looking for?',
	textFind: 'Input 3 letters or characters',
	searchResults: 'Results of your search',
	seeCard: 'See card',
	only15Letters: 'Only 15 characters.',
	rename: 'Rename',
	sendLinkResetPassword: 'E-mail change password',
	end: 'END',
	deliverPrizes: 'Deliver prizes',
	confirm: 'Confirm',
	awardsConfirmText:
		'Are you sure to continue? <br />This option cannot be undone.',
	donateTitle: 'We appreciate the support provided',
	donateThanks: 'Thanks for your support.',
	donateText:
		'<p>The organization ITFA America thanks all the people who in one way or another appreciate the hard work done by the administration of this page in which multiple tournaments of great renown and high competitiveness are organized.</p><p>To all these sponsors who anonymously perform.</p><p>We are grateful for the contribution, since they motivate us to continue with this great project by improving the page and maintaining it.</p>',
	donate: 'donate | donations',
	amountToDonate: 'Amount to donate',
	premiumForMonth: 'Price valid for 1 month | Price valid for {month} months',
	priceForMonth: '1 month | {month} months',
	movements: 'Movements',
	transferIn: '{player} is now a {team} player',
	transferOut: '{player} left the club {team}',
	changeCup: 'Change cup',
	banned: 'Banned',
	reason: 'Reason',
	bannedStart: 'Start',
	bannedEnd: 'Bathed up',
	countries: 'Countries',
	change: 'Change',
}
